module.exports = __webpack_public_path__ + "img/dish1.407265b3.png";